module.exports = __webpack_public_path__ + "static/media/Developmentbanner.b2ddf7e4.png";